import { TrackingFeatureLabels } from "../types";

export default class Slide {

    readonly slideDom: Element;
    private urlPath: string;
    readonly featureLabels: TrackingFeatureLabels;
    readonly position: number;


    constructor(slideDom: Element) {
        this.slideDom = slideDom;
        this.position = parseInt(slideDom.getAttribute("data-index")!) + 1;
        this.urlPath = slideDom.querySelector("a")!.getAttribute("href")!;
        this.featureLabels = JSON.parse(slideDom.getAttribute('data-feature-labels')!);
    }

    setIsTrackedAsVisible() {
        this.slideDom.setAttribute("data-is-tracked-visible", String(true));
    }

    isTrackedAsVisible() {
        return this.slideDom.getAttribute("data-is-tracked-visible") === "true";
    }

    registerClickEventHandler(eventHandler: (e: Event) => void) {
        this.slideDom.addEventListener("click", eventHandler);
    }

    /*           */
    click() {
        (this.slideDom as HTMLElement).click();
    }
}